import request from './request';

export const ROLE_GET_LIST = 'amp2.RoleSrv/GetSpecifyRoleList';

export default class Role {
  static async fetch(params) {
    try {
      const res = await request.post(ROLE_GET_LIST, params);
      return res;
    } catch (error) {
      throw error;
    }
  }
}

